import * as axios from 'axios';


function sendFormData(formData) {

    console.log(process.env);
    const url = `${process.env.VUE_APP_ROOT_API}/mediaupload`;

    return axios.post(url, formData)
        // get data
        .then(function (x) {
            console.log('data', x);
            return x.data

        })

}

export { sendFormData }